import React, { useState, useEffect, useContext } from "react";
import "./ProjectSidebar.scss";
import { Link /*withRouter*/ } from "react-router-dom";
import "./Calendar.scss";
import db from "../../../api/mongodb";
import { UserContext } from "../../../api/UserProvider";

const ProjectSidebar = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeProjectView, setActiveProjectView] = useState(true);
  const [btypes, setBtypes] = useState([]);
  const [cnames, setCNames] = useState([]);
  const [mobilesidebar, setMobileSide] = useState(false);
  const userid = useContext(UserContext).id;
  useEffect(() => {
    apiCall();
  }, []);

  const apiCall = async () => {
    const userName = sessionStorage.getItem("name");

    var response = await db.get(`/api/safeAPs/${userid}`, {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    });

    const primary = response.data.projects.primary;
    const secondary = response.data.projects.secondary;
    const allProjects = primary.concat(secondary);

    var response;
    let types = [];
    let clients = [];

    response = await db.put(
      "/api/projects/find/multiple",
      {
        ids: allProjects,
      },
      {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      }
    );

    if (userName !== "Admin") {
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response.data[i].property.length; j++) {
          if (!types.includes(response.data[i].property[j].type)) {
            types.push(response.data[i].property[j].type);
          }
        }
        // var name =
        //   response.data[i].client.fullName.first +
        //   " " +
        //   response.data[i].client.fullName.last;
        // if (!clients.includes(name)) clients.push(name);
      }
      setBtypes(types);
      setCNames(clients);
    } else {
      response = await db.get(`/api/projects`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      });

      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response.data[i].property.length; j++) {
          if (!types.includes(response.data[i].property[j].type)) {
            types.push(response.data[i].property[j].type);
          }
        }
        var name =
          response.data[i].client.fullName.first +
          " " +
          response.data[i].client.fullName.last;
        if (!clients.includes(name)) clients.push(name);
      }
      setBtypes(types);
      setCNames(clients);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    props.history.push(`/projects/search/${searchTerm}`);
  };

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const setActiveNav = (e, val) => {
    setActiveProjectView(val);
  };

  const changefilter = (e) => {
    e.preventDefault();
    props.history.push(`/projects/filter/${e.target.value}`);
  };

  const changeclient = (e) => {
    e.preventDefault();
    props.history.push(`/projects/client/${e.target.value}`);
  };

  const togglemenu = () => {
    if (!mobilesidebar) {
      document.getElementsByClassName("project-content-pane")[0].style.display =
        "none";
      document.getElementsByClassName("nav-proj")[0].style.width = "100vw";
      document.getElementsByClassName("nav-proj")[0].style.height = "100vh";
      document.getElementsByClassName(
        "project-nav-searchbar"
      )[0].style.display = "flex";
      document.getElementsByClassName("toggle-projects-view")[0].style.display =
        "inline-flex";
      document.getElementsByClassName(
        "toggle-projects-view"
      )[0].style.marginLeft = "5%";
      document.getElementsByClassName("project-nav-links")[0].style.display =
        "inline-block";
      document.getElementsByClassName("project-nav-links")[0].style.marginLeft =
        "5%";
      document.getElementsByClassName("proj-filters-header")[0].style.display =
        "inline-block";
      document.getElementsByClassName(
        "proj-filters-header"
      )[0].style.marginLeft = "5%";
      document.getElementsByClassName("filter-box")[0].style.display =
        "inline-block";
      document.getElementsByClassName("filter-box")[1].style.display =
        "inline-block";
      document.getElementsByClassName("filter-box")[0].style.marginLeft = "5%";
      document.getElementsByClassName("filter-box")[1].style.marginLeft = "5%";
      document.getElementsByClassName("proj-search")[1].style.width = "90vw";
      setMobileSide(true);
    } else if (mobilesidebar) {
      document.getElementsByClassName("project-content-pane")[0].style.display =
        "";
      document.getElementsByClassName(
        "project-nav-searchbar"
      )[0].style.display = "none";
      document.getElementsByClassName("toggle-projects-view")[0].style.display =
        "none";
      document.getElementsByClassName("project-nav-links")[0].style.display =
        "none";
      document.getElementsByClassName("proj-filters-header")[0].style.display =
        "none";
      document.getElementsByClassName("filter-box")[0].style.display = "none";
      document.getElementsByClassName("filter-box")[1].style.display = "none";
      document.getElementsByClassName("nav-proj")[0].style.width =
        "fit-content";
      document.getElementsByClassName("nav-proj")[0].style.height = "auto";
      setMobileSide(false);
    }
  };

  return (
    // <div className="nav-proj">
    //   <img
    //     src="https://img.icons8.com/material-outlined/48/ffffff/menu--v1.png"
    //     className="collapse-menu"
    //     onClick={togglemenu}
    //     alt=""
    //   />
    //   <div className="project-nav-searchbar" onSubmit={handleSearch}>
    //     <form className="proj-search">
    //       <input
    //         type="text"
    //         onChange={handleChange}
    //         className="proj-search"
    //         placeholder="Search project.."
    //       />
    //       <button type="submit">
    //         <i className="fas fa-search"></i>
    //       </button>
    //     </form>
    //   </div>
    //   <div className="toggle-projects-view">
    //     <i className="fas fa-th fa-lg"></i>
    //     <i className="fas fa-list-ul fa-lg"></i>
    //   </div>
    //   <div className="project-nav-links">
    //     <Link
    //       to="/projects/active"
    //       style={{
    //         fontSize: "inherit",
    //         padding: "inherit",
    //         textDecoration: "none",
    //         backgroundColor: "inherit",
    //         color: "inherit",
    //       }}
    //     >
    //       <div
    //         onClick={(e) => setActiveNav(e, true)}
    //         className={
    //           activeProjectView
    //             ? "project-nav-link project-nav-link-active"
    //             : "project-nav-link"
    //         }
    //       >
    //         <div> Active</div>
    //       </div>
    //     </Link>
    //     <Link
    //       to="/projects/completed"
    //       style={{
    //         fontSize: "inherit",
    //         padding: "inherit",
    //         textDecoration: "none",
    //         backgroundColor: "inherit",
    //         color: "inherit",
    //       }}
    //     >
    //       <div
    //         onClick={(e) => setActiveNav(e, false)}
    //         className={
    //           activeProjectView
    //             ? "project-nav-link"
    //             : "project-nav-link project-nav-link-active"
    //         }
    //       >
    //         <div> Completed </div>
    //       </div>
    //     </Link>
    //     {/* <div className="project-nav-link">Pending approval</div> */}
    //   </div>
    //   <div className="proj-filters-header">
    //     <div className="proj-filters-text">Filters</div>
    //   </div>
    //   <div className="filter-box">
    //     <div className="filter-title">Property Type</div>
    //     <select
    //       className="filter-bar"
    //       defaultValue="DEFAULT"
    //       onChange={changefilter}
    //     >
    //       <option value="DEFAULT" disabled>
    //         Select type...
    //       </option>
    //       {btypes.map((types, index) => (
    //         <option key={index} value={types}>
    //           {types}
    //         </option>
    //       ))}
    //     </select>
    //   </div>
    //   <div className="filter-box">
    //     <div className="filter-title">Client</div>
    //     <select
    //       className="filter-bar"
    //       defaultValue="DEFAULT"
    //       onChange={changeclient}
    //     >
    //       <option value="DEFAULT" disabled>
    //         Select one...
    //       </option>
    //       {cnames.map((names, index) => (
    //         <option key={index} value={names}>
    //           {names}
    //         </option>
    //       ))}
    //     </select>
    //   </div>
    //   {/*
    //             <div className="apply-filter-button-cont">
    //                 <div className="apply-filter-button">
    //                     Reset
    //                 </div>
    //             </div>
    //             */}
    // </div>

    <></>
  );
};

// export default withRouter(ProjectSidebar);
export default ProjectSidebar;
